export const name = "ARRAY_REVERSE";
export const summary = `Reverses the order of elements in an array.`;
export const reference = `
## ARRAY_REVERSE

Reverses the order of elements in an array.

\`\`\`
ARRAY_REVERSE(value)
\`\`\`

### Description

Returns the input \`ARRAY\` with elements in reverse order.


### Return type

\`ARRAY\`


### Examples



\`\`\`
SELECT ARRAY_REVERSE([1, 2, 3]) AS reverse_arr

/*-------------*
 | reverse_arr |
 +-------------+
 | [3, 2, 1] |
 *-------------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/array_functions
`;
